import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { AccessorType, Serie, Dimensions } from '../../models';

@Component({
    selector: '[aaCircles]',
    templateUrl: './circles.component.html',
    styleUrls: [
        './circles.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CirclesComponent implements OnInit
{
    @Input() dimensions: Dimensions;
    @Input() serie: Serie;
    @Input() keyAccessor: AccessorType;
    public radius: number = 4;

    ngOnInit (): void
    {
        this.radius = this.serie.radius ? this.serie.radius : 4;
    }
}
